export default __webpack_public_path__ + "static/media/brakes.51677a91.svg";